import { lazy } from '@loadable/component';

const AccommodationFlow = lazy(() =>
  import(
    /* webpackChunkName: "accommodation-flow" */
    './accommodation_flow'
  )
);

export default AccommodationFlow;
